import { api } from 'app/config/apiConfig';
import { WarehouseRevenueStatisticsObject } from '../model/types';

interface Params {
  warehouseId?: string | string[];
  isApplicable?: boolean;
  startDate?: string;
  endDate?: string;
}

export const getWarehousesRevenueStatisticsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getWarehousesRevenueStatistics: build.query<WarehouseRevenueStatisticsObject[], Params>({
      query: (args) => ({
        url: '/warehouses/statistics/warehouses-revenue',
        params: args,
      }),
    }),
  }),
});

export const { useGetWarehousesRevenueStatisticsQuery } = getWarehousesRevenueStatisticsApi;
